
export default class Formatters {

  static _decimal = new Intl.NumberFormat('en-US', {
    style: "decimal",
    useGrouping: false,
  });

  static _USD = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  });

  static _USD_NoFraction = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 2,
  });

  static _ShortUSDate = new Intl.DateTimeFormat('en-US', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    // dateStyle: 'full',
    // timeStyle: 'long',
    // timeZone : 'UTC',
    // timeZoneName : 'short',
    // hour: 'numeric', minute: 'numeric', second: 'numeric', fractionalSecondDigits : 3
  });

  static _ShortUSDateTime = new Intl.DateTimeFormat('en-US', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour12: true,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h12',
    // dateStyle: 'full',
    // timeStyle: 'long',
    // timeZone : 'UTC',
    // timeZoneName : 'short',
    // hour: 'numeric', minute: 'numeric', second: 'numeric', fractionalSecondDigits : 3
  });

  static _ShortUSDateTimeAmericaNewYork = new Intl.DateTimeFormat('en-US', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour12: true,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h12',
    // dateStyle: 'full',
    // timeStyle: 'long',
    timeZone: 'America/New_York',
    // timeZoneName : 'short',
    // hour: 'numeric', minute: 'numeric', second: 'numeric', fractionalSecondDigits : 3
  });

  static ToCurrencyUSD(n: number): string {
    if (isNaN(n))
      return '';

    if (n % 1 === 0)
      return Formatters._USD_NoFraction.format(n);

    return Formatters._USD.format(n);
  }

  static ToDecimal(n: number): string {
    if (isNaN(n))
      return '';

    return Formatters._decimal.format(n);
  }

  static ToEmptyString(input: string): string {
    return " ";
  }

  /**
   * 
   * @param input ISO Date representation
   * @returns Date in user timezone
   */
  static ToShortDate(input: string): string {
    return Formatters._ShortUSDate.format(new Date(input));
    // return (new Date(input)).toLocaleString('en-US', { dateStyle: "short", timeZone: "UTC" });
  }

  /**
   * 
   * @param input ISO Date representation
   * @returns Date + Time in user timezone
   */
  static ToShortDateTime(input: string): string {
    return Formatters._ShortUSDateTime.format(new Date(input));
    // return (new Date(input)).toLocaleString('en-US', { dateStyle: "short", timeZone: "UTC" });
  }


  /**
  * 
  * @param input ISO Date representation
  * @returns Date + Time in user timezone
  */
  static ToShortDateTimeAmericaNewYork(input: string): string {
    return Formatters._ShortUSDateTimeAmericaNewYork.format(new Date(input)) + " ET";

  }

  /**
   * 
   * @param input JS Date
   * @returns Date + Time in user timezone
   */
  static ToShortDateTimeFromJSDate(input: Date): string {
    return Formatters._ShortUSDateTime.format(input);
    // return (new Date(input)).toLocaleString('en-US', { dateStyle: "short", timeZone: "UTC" });
  }

  static ToPercentage(input: string): string {
    if (!input)
      return "-";
    return parseFloat(input).toLocaleString("en", { style: "percent" })
  }

  static ToPercentageWithNC(input: any): any {
    if (input === null)
      return "-";
    else if (input === "1")
      return (<abbr title="Not Covered">NC</abbr>);
    else if (input === 1)
      return (<abbr title="Not Covered">NC</abbr>);
    else
      return Formatters.ToPercentage(input);
  }

  static ToLink(input: string, options: any): any {
    return input ? (<a href={input} rel="noreferrer" target="_blank">{options.column.fieldName}</a>) : "-";
  }


  static ToLookup(input: string, mapping: any): string {
    return mapping[input];
  }

  static ToLookupYesNo(input: boolean, mapping: any): string {
    if (input)
      return "Yes"
    else if (!input)
      return "No";

    return "";
  }
}